import { ITransactionExtension, ITransactionExtensionFieldName } from "@/Interfaces";
import { AjaxHelper } from "@samc/common";

export class PackageService {
  private readonly _helper: AjaxHelper;

  public constructor(verificationToken: string | null, client: string | null, jwt: string | null) {
    this._helper = new AjaxHelper("/componentapi/package", verificationToken, client, jwt);
  }

  /**
   * Returns the extension information for a package.
   * 
   * @param id The ID of the package to retrieve the transaction extension for.
   * @returns Will return the transaction extension data for a package
   */
  public async getTransactionExtension(id: string) {
    return await this._helper.getData<ITransactionExtension>(`${id}/extension`);
  }

  /**
   * Updates the transaction extension for a package.
   * 
   * @param id The ID of the package
   * @param extension The transaction extension details we want to update
   * @returns Will return the newly updated transaction extension data
   */
  public async updateTransactionExtension(id: string, extension: ITransactionExtension) {
    return await this._helper.patchData<ITransactionExtension>(`${id}/extension`, extension);
  }

  /**
   * Gets the transaction extension field names
   * 
   * @param isDeal Indicates whether the transaction extension field names are for a deal or not.
   * @returns Will return the transaction extension field names for a deal or not.
   */
  public async getTransactionExtensionFieldNamesAsync(isDeal: boolean) {
    return await this._helper.getData<ITransactionExtensionFieldName[]>(`transactionextensionfieldname?isDeal=${isDeal}`);
  }

  /**
   * Updates the transaction extension field name
   * 
   * @param field The transaction extension name mean to be updated in the backend
   * @returns Will return the newly updated field name
   */
  public async updateTransactionExtensionFieldNameAsync(field: ITransactionExtensionFieldName) {
    return await this._helper.patchData<ITransactionExtensionFieldName>('transactionextensionfieldname', field);
  }
}